// TODO actually migrate the roles to rename them

import type { UserRole } from '@ils/static/enums.js';
import type { RolesWithPermissions } from './permissions.js';

// TODO this is quite a big job, because there are multiple entities with fields still using the initial "trainee"/"tester" naming which have to be migrated alongside the users
export const roleMapping: Record<UserRole, keyof RolesWithPermissions> = {
  admin: 'admin',
  accounting: 'accounting',
  tester: 'actor',
  trainee: 'candidate',
  digifort: 'digifort',
  examCenter: 'examCenter',
  examCenterManager: 'examCenterManager',
  inspector: 'inspector',
  support: 'support',
  resolveErrors: 'resolveErrors',
};
